// Visitor statistics go to our own Umami at stats.jesteswdomu.com. It sets no cookies, so the site
// needs no consent banner. The script counts page views itself (it follows the history API, so
// client-side navigation counts too) and reads utm_* from the address; the few actions that matter
// for a campaign are reported with track().
const WEBSITE_ID = process.env.REACT_APP_UMAMI_WEBSITE_ID;
const HOST = "https://stats.jesteswdomu.com";

export function installAnalytics(): void {
  if (!WEBSITE_ID) return;
  const script = document.createElement("script");
  script.defer = true;
  script.src = `${HOST}/script.js`;
  script.dataset.websiteId = WEBSITE_ID;
  document.head.appendChild(script);
}

type Umami = { track: (event: string, data?: Record<string, string | number | boolean>) => void };

export function track(event: string, data?: Record<string, string | number | boolean>): void {
  try {
    (window as Window & { umami?: Umami }).umami?.track(event, data);
  } catch {
    // statistics never break the page
  }
}
